module.exports = __webpack_public_path__ + "static/Ettin-649bcfe3fe1ba7b202502bdc4857a424.jpg";